enum ActionType {
    AddProductsAction = 'AddProductsAction',
    ChangeBillAssociatedAccount = 'ChangeBillAssociatedAccountAction',
    ChangeBillOwner = 'ChangeBillOwnerAction',
    ChangeBillingDetailsAction = 'ChangeBillingDetailsAction',
    Command = 'CommandAction',
    ConfirmationDialog = 'ConfirmationDialogAction',
    ConfirmationDialogWithCheck = 'ConfirmationDialogWithCheckAction',
    Custom = 'CustomAction',
    Dropdown = 'DropdownAction',
    FilterToggle = 'FilterToggleAction',
    IdentityDocumentScanner = 'IdentityDocumentScannerAction',
    Link = 'LinkAction',
    Loading = 'LoadingAction',
    ModalOpener = 'ModalOpenerAction',
    Print = 'PrintAction',
    PrintFinancialDocument = 'PrintFinancialDocumentAction',
    ReinstateBill = 'ReinstateBillAction',
    SearchPage = 'SearchPageAction',
    SendBillToCustomer = 'SendBillToCustomerAction',
    SendEmailAndReminderForInvoiceToEmailAction = 'SendEmailAndReminderForInvoiceToEmailAction',
    SendFinancialDocumentToEmail = 'SendFinancialDocumentToEmailAction',
    ToggleSwitch = 'ToggleSwitchAction',
}

export default ActionType;
